import { getTranslations } from '../api';
import { addLocaleData } from 'react-intl';

/* export const getTranslationsFromApi = () => (
  getTranslations().then((data) => {
    for (var locale in data.body) {
      let localeData;
      if (window.IntlPolyfill) {
        localeData = require(`intl/locale-data/jsonp/${locale}`);
      } else {
        localeData = require(`react-intl/lib/locale-data/${locale}`);
      }
      addLocaleData(localeData);
    }
    return Promise.resolve(data.body);
  }).catch((e) => Promise.reject(e))
); */

export default (() => {
  const req = require.context('./', true, /\.json.*$/);
  const exports = {};

  req.keys().forEach((file) => {
    const locale = file.replace('./', '').replace('.json', '');
    if (locale === 'en' && window.IntlPolyfill) {
      require('intl/locale-data/jsonp/en.js');
    } else if (locale === 'en') {
      addLocaleData(require('react-intl/lib/locale-data/en.js'));
    } else if (locale === 'it' && window.IntlPolyfill) {
      require('intl/locale-data/jsonp/it.js');
    } else if (locale === 'it') {
      addLocaleData(require('react-intl/lib/locale-data/it.js'));
    }
    exports[locale] = req(file);
  });
  return exports;
})();



/** WEBPACK FOOTER **
 ** ./src/i18n/index.js
 **/